// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/OTF/LuxoraGrotesk-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/TTF/LuxoraGrotesk-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/OTF/LuxoraGrotesk-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/TTF/LuxoraGrotesk-Thin.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
}

.App-header {
  position: relative;
}

a {
  color: black;
  text-decoration: none; /* no underline */
}

@font-face {
  font-family: 'LuxoraGoretsk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'LuxoraGoretskThin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype'),
      url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

.each-slide {
  display: flex;
  justify-content: flex-end; /* Slaytın sağ kenarına hizala */
}

.word {
  padding: 20px; /* Kelimenin etrafına boşluk ekleyin */
  animation: slideInRight 0.5s ease-in-out; /* Sağdan gelen animasyon */
}

body {
  font-family: 'LuxoraGoretsk';
}

/* Position and sizing of burger button */
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
}

/* Color/shape of burger icon bars */
.bm-burger-bars {
  background: #373a47;
}

/* Color/shape of burger icon bars on hover*/
.bm-burger-bars-hover {
  background: #a90000;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #bdc3c7;
}

/*
Sidebar wrapper styles
Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
*/
.bm-menu-wrap {
  position: fixed;
  height: 100%;
  top: 0%;
  left: 0;
}

/* General sidebar styles */
.bm-menu {
  background: #000000e5;
  padding: 2.5em 0.5em 0;
  font-size: 1.5em;
  font-family: LuxoraGoretsk;
}

/* Morph shape necessary with bubble or elastic */
.bm-morph-shape {
  fill: #373a47;
}

/* Wrapper for item list */
.bm-item-list {
  color: #b8b7ad;
  padding: 0.8em;
}

/* Individual item */
.bm-item {
  display: inline-block;
  margin-top: 10%;
  color: white;
}

/* Styling of overlay */
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
  top: 0%;
}

/* Styling of close button */
.bm-cross-button span {
  top: 14px !important;
  right: 20px !important;
} 

.bm-cross-button {
  width: 60px !important;
  height: 60px !important;
  right: 0px !important;
  top: 0px !important;
}

/* Swiper */
.swiper {
  width: 100%;
  height: 100%;
}

.swiper .swiper-button-prev {
  width: 10px;
  scale: 0.8;
}

.swiper .swiper-button-next {
  width: 10px;
  scale: 0.8;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: transparent;

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,4BAA4B;EAC5B;gEACuE;AACzE;;AAEA;EACE,gCAAgC;EAChC;gEACuE;AACzE;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,aAAa,EAAE,sCAAsC;EACrD,wCAAwC,EAAE,2BAA2B;AACvE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;;;CAGC;AACD;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,OAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,OAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;;EAEvB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.App-header {\n  position: relative;\n}\n\na {\n  color: black;\n  text-decoration: none; /* no underline */\n}\n\n@font-face {\n  font-family: 'LuxoraGoretsk';\n  src: url('./assets/fonts/OTF/LuxoraGrotesk-Book.otf') format('opentype'),\n      url('./assets/fonts/TTF/LuxoraGrotesk-Book.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'LuxoraGoretskThin';\n  src: url('./assets/fonts/OTF/LuxoraGrotesk-Thin.otf') format('opentype'),\n      url('./assets/fonts/TTF/LuxoraGrotesk-Thin.ttf') format('truetype');\n}\n\n.each-slide {\n  display: flex;\n  justify-content: flex-end; /* Slaytın sağ kenarına hizala */\n}\n\n.word {\n  padding: 20px; /* Kelimenin etrafına boşluk ekleyin */\n  animation: slideInRight 0.5s ease-in-out; /* Sağdan gelen animasyon */\n}\n\nbody {\n  font-family: 'LuxoraGoretsk';\n}\n\n/* Position and sizing of burger button */\n.bm-burger-button {\n  position: fixed;\n  width: 36px;\n  height: 30px;\n  left: 36px;\n  top: 36px;\n}\n\n/* Color/shape of burger icon bars */\n.bm-burger-bars {\n  background: #373a47;\n}\n\n/* Color/shape of burger icon bars on hover*/\n.bm-burger-bars-hover {\n  background: #a90000;\n}\n\n/* Color/shape of close button cross */\n.bm-cross {\n  background: #bdc3c7;\n}\n\n/*\nSidebar wrapper styles\nNote: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases\n*/\n.bm-menu-wrap {\n  position: fixed;\n  height: 100%;\n  top: 0%;\n  left: 0;\n}\n\n/* General sidebar styles */\n.bm-menu {\n  background: #000000e5;\n  padding: 2.5em 0.5em 0;\n  font-size: 1.5em;\n  font-family: LuxoraGoretsk;\n}\n\n/* Morph shape necessary with bubble or elastic */\n.bm-morph-shape {\n  fill: #373a47;\n}\n\n/* Wrapper for item list */\n.bm-item-list {\n  color: #b8b7ad;\n  padding: 0.8em;\n}\n\n/* Individual item */\n.bm-item {\n  display: inline-block;\n  margin-top: 10%;\n  color: white;\n}\n\n/* Styling of overlay */\n.bm-overlay {\n  background: rgba(0, 0, 0, 0.3);\n  top: 0%;\n}\n\n/* Styling of close button */\n.bm-cross-button span {\n  top: 14px !important;\n  right: 20px !important;\n} \n\n.bm-cross-button {\n  width: 60px !important;\n  height: 60px !important;\n  right: 0px !important;\n  top: 0px !important;\n}\n\n/* Swiper */\n.swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.swiper .swiper-button-prev {\n  width: 10px;\n  scale: 0.8;\n}\n\n.swiper .swiper-button-next {\n  width: 10px;\n  scale: 0.8;\n}\n\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  background: transparent;\n\n  /* Center slide text vertically */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.swiper-slide img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
